
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'NewsSkeletonItem',

  setup() {
    return {};
  },
});
